<template>
  <router-link class="permalink" :class="{small: small}" :to="permalink" v-on:click.stop>{{ desc }}</router-link>
</template>

<script>
export default {
  props: {
    image: Object,
    artist: Object,
    small: Boolean
  },
  computed: {
    permalink () {
      if(this.image && this.artist) {
        if(this.image.url){
          return this.$k.getImagePermalink(this.image, this.artist)
        }
        
      }
      return ''
    },
    desc () {
      if(!this.image){
        return ''
      }
      if(!this.image.detail) {
        return this.image.alt
      }
      return this.image.detail.title || this.image.detail.description || this.image.alt
    }
    
  }

}
</script>
<style>
a.permalink{
  width:14px;
  height:14px;
  background-repeat: no-repeat;
  background-image: url('../../assets/img/circle-gold.svg');
  background-size: contain;
  cursor:pointer;
  opacity:0.5;
  display:block;
  position:absolute;
  bottom:14px;
  right:16px;
  color:transparent;
}

a.permalink.small{
  width:10px;
  height:10px;
  bottom:4px;
  right:4px;
}

.permalink:hover{
  opacity:0.9;
  background-image: url('../../assets/img/circle.svg');
}
</style>